import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getVisitTrackView = get('guest.routes.visitTrackView');

export const getVisitTrackViewData = createSelector(
  getVisitTrackView,
  get('data')
);

export const getIsFetching = createSelector(getVisitTrackView, get('fetching'));

export const getIsFetched = createSelector(getVisitTrackView, get('fetched'));
